import { gql } from '@apollo/client';

const UPDATE_HELP_ARTICLE = gql`mutation updateHelpArticle($input: HelpArticleInput!) {
  helpContext {
    updateHelpArticle(input: $input) {
      id
      topicId
      index
      title
      description
      content
      related
      tags
    }
  }
}`;

export default UPDATE_HELP_ARTICLE;
